import translationApi from './api/translationApi';

export const TRANSLATION_INSERT = 'translation/INSERT';
export const TRANSLATION_LIST = 'translation/LIST';
export const TRANSLATION_SEARCH = 'translation/SEARCH';

const initialState = {
	data: null,
	search: null
	
}

export default (state = initialState, action) => {
	switch (action.type) {
		case TRANSLATION_LIST:
			return {
				...state,
				data: action.payload
			};
		case TRANSLATION_SEARCH:
			return {
				...state,
				search: action.payload
			};
		default:
			return state;
		
	}
};

export const translationInsert = (payload) => {
	return dispatch => {
		return translationApi.TranslationInsert(payload).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const translationUpdate = (payload, id) => {
	return dispatch => {
		return translationApi.TranslationUpdate(payload, id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const translationList = () => {
	return dispatch => {
		return translationApi.TranslationList().then(data => {
			dispatch({
				type: TRANSLATION_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const translationDelete = (id) => {
	return dispatch => {
		return translationApi.TranslationDelete(id).then(data => {
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};


export const translationListChange = (page, pageSize) => {
	return dispatch => {
		return translationApi.TranslationListChange(page, pageSize).then(data => {
			dispatch({
				type: TRANSLATION_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};

export const translationSearch = (title) => {
	return dispatch => {
		return translationApi.TranslationSearch(title).then(data => {
			dispatch({
				type: TRANSLATION_SEARCH,
				payload: data
			});
			return data;
		}).catch(error => {
			throw(error);
		});
	};
};